import { Component, OnDestroy, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../../store/reducers';
import { TestTakerActions, AppUiActions } from '../../../store/actions';
import { MyModal } from '../../common/my-modal/my-modal.component';
import * as Enum from '../../../dtos/enums';
import { AuthService } from '../../../services/auth.service';
import { TestContentService } from '../../../services/test-content.service';
import { TestTakerService } from '../../../services/test-taker.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'start-screen-pin',
    template: require('./start-screen-pin.component.html')
})
export class StartScreenPinComponent implements OnDestroy, OnInit {
    stationNumber: number;
    testTakerPhotoUrl: string;
    errorMsg: string;
    testTakerInfo: PgRendererDto.TestTakerStationAssignment = {} as any;
    private routeParamsSubscription: Subscription;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private store: Store<fromRoot.State>,
        private myModal: MyModal,
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.routeParamsSubscription = this.route.params.subscribe(params => {
            if (params) {
                const stationNumber = params['station-number'];
                if (!this.testTakerService.testTakerInfo) {
                    this.router.navigate([`start-screen/${stationNumber}/pending`]);
                } else {
                    this.stationNumber = stationNumber;
                    this.testTakerInfo = this.testTakerService.testTakerInfo;
                    this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(this.testTakerInfo.BrandName, this.testTakerInfo.TestSessionSiteCode, this.testTakerInfo.TestTakerId);
                }

                if (this.testTakerInfo.IsNonScored === true) {
                    this.testTakerService.authenticate(this.testTakerInfo, _paragonConfig.version).subscribe(authSuccessResult => {
                        this.authService.setAccessToken(authSuccessResult.access_token);

                        Observable.interval(5000)
                        .startWith(1)
                        .flatMap(x => this.testTakerService.isNonScoredTestStarted())
                        .filter(x => x === true)
                        .take(1)
                        .retryWhen(errors => errors.delay(60000))
                        .subscribe(x => {
                            this.onNonScoredTestStarted();
                        });

                    });
                }
            }
        });
    }

    onNonScoredTestStarted() {
        this.testTakerService.startTest().subscribe(
            success => {
                this.store.dispatch(new TestTakerActions.SetTestInitializationInfo(success));
                this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.StartCodeCorrectInput);
                this.router.navigate([`assessment-test/${this.testTakerInfo.AssessmentTestId}`]);
            },
            error => {
                this.myModal.showRegularDlg("Error", error);
                setTimeout(() => {
                    window.location.reload(true);
                }, 90000);
            }
        );
    }

    ngOnDestroy() {
        this.routeParamsSubscription.unsubscribe();
    }

    txtPinKeyDown(event: KeyboardEvent, pin: string) {
        this.clearErrorMsg();
        if (event.keyCode == 13) {
            this.onVerifyPin(pin);
        }
    }

    clearErrorMsg() {
        this.errorMsg = "";
    }

    onVerifyPin(pin: string) {
        if (this.authService.getAccessToken()) {
            this.verifyPin(pin);
        } else {
            this.testTakerService.authenticate(this.testTakerInfo, _paragonConfig.version).subscribe(authSuccessResult => {
                this.authService.setAccessToken(authSuccessResult.access_token);
                this.verifyPin(pin);
            });
        }
    }

    verifyPin(pin: string) {
        if (pin != this.testTakerInfo.PIN) {
            this.errorMsg = "Invalid PIN.";
            this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.PinWrongInput);
        } else {
            this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.PinCorrectInput);
            if (_paragonConfig.audioTestEnabled === true) {
                this.router.navigate([`start-screen/${this.stationNumber}/audio-check`]);
            } else {
                this.router.navigate([`start-screen/${this.stationNumber}/start-code`]);
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-pin.component.ts